import axios from 'axios'

import { checkLogin } from './axiosPost'

const axiosGet = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  timeout: 30000,
  timeoutErrorMessage:
    'Request timed out, please check your internet connectivity',
  method: 'GET',
})

axiosGet.interceptors.request.use(
  function (config) {
    return config
  },
  (error) => Promise.reject(error),
)

axiosGet.interceptors.response.use(
  function (response) {
    return response
  },
  (error) => {
    const originalRequest = error.config
    if (error.response.status === 401) {
      const payload = {
        refresh: localStorage.getItem('refresh'),
      }
      return checkLogin(`login/refresh/`, { data: payload })
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem('access', res.data.access)
            originalRequest.headers.Authorization = `Bearer ${res.data.access}`
            return axiosGet(originalRequest)
          }
        })
        .catch((err) => {
          if (axios.isAxiosError(err)) {
            if (err.response.status === 401 || err.response.status === 403) {
              localStorage.removeItem('refresh')
              localStorage.removeItem('access')
              window.location.reload()
            }
          }
          return Promise.reject(err)
        })
    }
    return Promise.reject(error)
  },
)

export const fetchTeacherSaleAgreements = () =>
  axiosGet
    .get('/teacher-sale-agreement/', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access')}`,
      },
    })
    .then((res) => res.data)

export const fetchParentSaleAgreements = () =>
  axiosGet
    .get('/parent-sale-agreement/', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access')}`,
      },
    })
    .then((res) => res.data)

export const fetchAgreementPdfUrl = (saleOrderId) =>
  axiosGet
    .get(`/teacher-sale-agreement/${saleOrderId}/download-pdf/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access')}`,
      },
    })
    .then((res) => res.data)

export const fetchParentAgreementPdfUrl = (saleOrderId) =>
  axiosGet
    .get(`/parent-sale-agreement/${saleOrderId}/download-pdf/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access')}`,
      },
    })
    .then((res) => res.data)

export const fetchAgreementsBySaleOrders = (
  saleOrders,
  confirmationDone = false,
) =>
  axiosGet
    .get(`/parent-sale-agreement/`, {
      params: {
        sale_orders: saleOrders.join(','),
        confirmation_done: confirmationDone,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access')}`,
      },
    })
    .then((res) => res.data)

export const fetchTeacherAgreementsBySaleOrders = (
  saleOrders,
  confirmationDone = false,
) =>
  axiosGet
    .get(`/teacher-sale-agreement/`, {
      params: {
        sale_orders: saleOrders.join(','),
        confirmation_done: confirmationDone,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access')}`,
      },
    })
    .then((res) => res.data)

export default axiosGet
